import { useEffect, useState } from "react";
import {
  PubListFormWrapper,
  PubListItemWrapper,
  PubListWrapper,
} from "./styles";
import { PubDetail } from "../../api/cafe";
import { getPubList, getSellerToken } from "../../api/admin-pub";
import { useNavigate } from "react-router-dom";
import {
  clearCredential,
  LOCAL_STORAGE_ACCESS_KEY,
  LOCAL_STORAGE_PUB_ID,
  LOCAL_STORAGE_SUPER_ADMIN_KEY,
  isAuthError,
} from "../../utils/network";
import { TOKEN_EXPIRED } from "../../api/code";
import { useRecoilValue } from "recoil";
import { WideState } from "../../recoil/wide";

const PubList = () => {
  const navigate = useNavigate();
  const superAdminToken = localStorage.getItem(LOCAL_STORAGE_SUPER_ADMIN_KEY);
  const isWide = useRecoilValue(WideState);

  if (!superAdminToken) {
    navigate("/login");
  }
  const [list, setList] = useState<PubDetail[]>([]);

  const handleSuperAdminLogout = () => {
    clearCredential();
    navigate("/login");
  };

  const isSuperAdminAuthError = (error: unknown) => {
    if (isAuthError(error)) return true;
    const err = error as { code?: number; response?: { data?: { code?: number } } };
    return (
      err.code === TOKEN_EXPIRED ||
      err.response?.data?.code === TOKEN_EXPIRED
    );
  };

  const getList = async () => {
    try {
      const res = await getPubList();
      setList(res);
    } catch (error) {
      if (isSuperAdminAuthError(error)) {
        alert("로그인이 만료되었습니다.");
        handleSuperAdminLogout();
      }
    }
  };

  useEffect(() => {
    getList();
  }, []);

  const handleClick = async (pubId: number) => {
    try {
      const res = await getSellerToken(pubId);
      localStorage.setItem(
        LOCAL_STORAGE_ACCESS_KEY,
        `Bearer ${res.accessToken}`,
      );
      localStorage.setItem(LOCAL_STORAGE_PUB_ID, String(pubId));
      navigate("/");
    } catch (e) {
      if (isSuperAdminAuthError(e)) {
        alert("로그인이 만료되었습니다.");
        handleSuperAdminLogout();
        return;
      }
      alert("해당 펍에 접근할 수 없습니다.");
    }
    if (isWide) {
      navigate("/");
    } else {
      navigate("/tournament");
    }
  };

  return (
    <PubListWrapper>
      <PubListFormWrapper>
        {list.map((item) => (
          <PubListItemWrapper
            key={item.id}
            onClick={() => handleClick(item.id)}
          >
            <div>{item.pubName}</div>
          </PubListItemWrapper>
        ))}
      </PubListFormWrapper>
    </PubListWrapper>
  );
};

export default PubList;
